export enum MediaBreakpoints {
  mobile = 375,
  tablet = 768,
  desktop = 1024,
  desktopXl = 1366,
}